"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[4087],{

/***/ 37695:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CK: () => (/* binding */ monoFontFamily),
/* harmony export */   Kc: () => (/* binding */ primitivesLight),
/* harmony export */   NK: () => (/* binding */ EditLayout),
/* harmony export */   Nj: () => (/* binding */ EditLightProductionTheme),
/* harmony export */   PW: () => (/* binding */ EditLightTheme),
/* harmony export */   Rv: () => (/* binding */ EditDarkProductionTheme),
/* harmony export */   f8: () => (/* binding */ editOverrides),
/* harmony export */   rH: () => (/* binding */ proseFamily),
/* harmony export */   sb: () => (/* binding */ primitivesDark),
/* harmony export */   wM: () => (/* binding */ EditDarkTheme)
/* harmony export */ });
/* unused harmony export defaultSemanticOverrides */
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70531);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92539);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75580);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1898);
/* eslint-disable @typescript-eslint/no-empty-object-type */ 



const monoFontFamily = `Inconsolata, Monaco, monospace`;
const proseFamily = `Inter, -apple-system, BlinkMacSystemFont, sans-serif`;
const editOverrides = {
    name: "edit",
    borders: {
        radius200: "4px",
        radius300: "8px",
        radius400: "10px",
        radius500: "12px",
        checkboxBorderRadius: "4px"
    },
    grid: {
        columns: [
            4,
            8,
            12
        ],
        gutters: [
            16,
            16,
            16
        ],
        margins: [
            0,
            12,
            24
        ]
    },
    lighting: {
        ..._primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetShadows */ .Ro,
        shadow400: "0px 1px 0px rgba(0, 0, 0, 0.07);",
        shadow700: "-2px 2px 0px rgba(0, 0, 0, 0.07);"
    },
    typography: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .generateTypography */ .l8)({
        primaryFamily: monoFontFamily,
        monoFamily: monoFontFamily
    }, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .productTypography */ .uQ)
};
var SemanticType;
(function(SemanticType) {
    SemanticType[SemanticType["Development"] = 0] = "Development";
    SemanticType[SemanticType["Production"] = 1] = "Production";
})(SemanticType || (SemanticType = {}));
const getSemanticOverrides = (type, colors)=>{
    const developmentOverrides = {
        colors: {
            ...colors,
            themedAlpha50: colors.alpha50,
            themedAlpha100: colors.alpha100,
            themedAlpha200: colors.alpha200,
            themedAlpha300: colors.alpha300,
            themedAlpha400: colors.alpha400,
            themedAlpha500: colors.alpha500,
            themedAlpha600: colors.alpha600,
            themedAlpha700: colors.alpha700,
            themedPrimary50: colors.primary50,
            themedPrimary100: colors.primary100,
            themedPrimary200: colors.primary200,
            themedPrimary300: colors.primary300,
            themedPrimary400: colors.primary400,
            themedPrimary500: colors.primary500,
            themedPrimary600: colors.primary600,
            themedPrimary700: colors.primary700,
            accent100: colors.electricBlue100,
            accent200: colors.electricBlue200,
            accent300: colors.electricBlue300,
            accent400: colors.electricBlue400,
            accent500: colors.electricBlue500,
            accent600: colors.electricBlue600,
            accent700: colors.electricBlue700,
            contentSecondary: colors.primary500,
            contentSecondaryOriginal: colors.primary600,
            contentAccent: colors.electricBlue500,
            contentInfo: colors.cyan700,
            contentNegative: colors.red500,
            contentWarning: colors.yellow700,
            contentPositive: colors.green700,
            contentDevelopment: colors.development,
            contentProduction: colors.purple500,
            contentDisabledDevelopment: colors.disabledDevelopment,
            backgroundTertiary: colors.primary50,
            backgroundQuaternary: colors.primary200,
            backgroundQuinary: colors.primary300,
            backgroundInverseTertiary: colors.primary700,
            backgroundInfo: colors.cyan50,
            backgroundNegative: colors.red50,
            backgroundWarning: colors.yellow50,
            backgroundPositive: colors.green50,
            backgroundSubtleBlue: colors.electricBlue50,
            backgroundProduction: "#C5ADFA36",
            border: colors.alpha300,
            borderFocus: colors.electricBlue500,
            borderSelected: colors.electricBlue400,
            borderOpaque: colors.alpha300,
            borderAlt: colors.primary200,
            borderInfo: colors.cyan500,
            borderNegative: colors.red500,
            borderError: colors.red500,
            borderWarning: colors.yellow600,
            borderPositive: colors.green200,
            buttonPrimaryFill: colors.primary700,
            buttonPrimaryHover: colors.primary600,
            buttonSecondaryFill: colors.neutralMin,
            buttonSecondaryHover: colors.primary50,
            buttonTertiaryHover: colors.alpha0,
            inputFill: "rgba(0, 0, 0, 0.01)",
            inputFillActive: colors.neutralMin,
            inputBorder: colors.primary300,
            inputBorderError: colors.red500,
            linkText: colors.primary700,
            linkVisited: colors.primary700,
            linkHover: colors.primary600,
            contentLinkText: colors.blue500,
            contentLinkHover: colors.blue600,
            contentLinkActive: colors.blue700,
            menuFontDefault: colors.neutralMax,
            tickBorderError: colors.red500,
            tickFillErrorSelected: colors.red500,
            tickFillErrorSelectedHover: colors.red600,
            tickFillErrorSelectedHoverActive: colors.red700,
            backgroundEnvironmentSettingsCallout: colors.backgroundEnvironmentSettingsCalloutDevelopment,
            contentEnvironmentSettingsCallout: colors.contentEnvironmentSettingsCalloutDevelopment
        },
        borders: {
            buttonBorderRadius: "6px",
            inputBorderRadius: "6px",
            popoverBorderRadius: "6px",
            surfaceBorderRadius: "8px",
            tableBorderRadius: "8px"
        }
    };
    if (type == 1) {
        const productionOverrides = {
            colors: {
                themedAlpha50: colors.purpleAlpha50,
                themedAlpha100: colors.purpleAlpha100,
                themedAlpha200: colors.purpleAlpha200,
                themedAlpha300: colors.purpleAlpha300,
                themedAlpha400: colors.purpleAlpha400,
                themedAlpha500: colors.purpleAlpha500,
                themedAlpha600: colors.purpleAlpha600,
                themedAlpha700: colors.purpleAlpha700,
                themedPrimary50: colors.purple50,
                themedPrimary100: colors.purple100,
                themedPrimary200: colors.purple200,
                themedPrimary300: colors.purple300,
                themedPrimary400: colors.purple400,
                themedPrimary500: colors.purple500,
                themedPrimary600: colors.purple600,
                themedPrimary700: colors.purple700,
                contentSecondaryOriginal: colors.purple600,
                contentInfo: colors.purple600,
                backgroundTertiary: colors.purple50,
                backgroundQuaternary: colors.purple100,
                backgroundQuinary: colors.purple300,
                backgroundInverseTertiary: colors.purple700,
                backgroundInfo: colors.purple50,
                borderFocus: colors.purple500,
                borderSelected: colors.purple400,
                borderOpaque: colors.purple200,
                borderAlt: colors.purple200,
                borderInfo: colors.purple200,
                tableStripedBackground: colors.purple50,
                backgroundEnvironmentSettingsCallout: colors.backgroundEnvironmentSettingsCalloutProduction,
                contentEnvironmentSettingsCallout: colors.contentEnvironmentSettingsCalloutProduction
            },
            borders: {
                // NOTE: These colours are opaque, while the default border colours are transparent
                border100: {
                    borderColor: colors.purple50
                },
                border200: {
                    borderColor: colors.purple100
                },
                border300: {
                    borderColor: colors.purple200
                },
                border400: {
                    borderColor: colors.purple300
                },
                border500: {
                    borderColor: colors.purple400
                },
                border600: {
                    borderColor: colors.purple500
                }
            }
        };
        return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, developmentOverrides, productionOverrides);
    } else {
        return developmentOverrides;
    }
};
// PRIMITIVE OVERRIDES ////////////////////////////////////////////////////////
const primitivesLight = {
    ...(0,_primitives__WEBPACK_IMPORTED_MODULE_1__/* .getPrimitiveColors */ .zG)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .d_)
};
const primitivesDark = {
    ...(0,_primitives__WEBPACK_IMPORTED_MODULE_1__/* .getPrimitiveColors */ .zG)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql)
};
// COLOR PALETTE OVERRIDES ////////////////////////////////////////////////////
const defaultSemanticOverrides = getSemanticOverrides(0, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .d_);
const EditLightTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(primitivesLight, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, defaultSemanticOverrides, editOverrides));
const EditLightProductionTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(primitivesLight, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(1, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .d_), editOverrides));
const EditDarkTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(primitivesDark, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(0, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql), editOverrides));
const EditDarkProductionTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(primitivesDark, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(1, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql), editOverrides));
// for debugging, its nice to be able to just see the theme values easily
if (false) {}
const EditLayout = {
    smallSubNavigationWidth: "368px",
    mediumSubNavigationWidth: "392px",
    minimumEditPaneWidth: "432px",
    maximumEditPaneWidth: "816px",
    connectionsIndexWidth: "1048px",
    connectionsModalWidth: "900px",
    appSettingIndexWidth: "1150px",
    resizablePaneStartWidth: 526
};


/***/ }),

/***/ 74888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ Column)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Column = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", (props)=>({
        display: "flex",
        flexDirection: "column",
        justifyContent: props.$align,
        gap: props.$gap,
        "data-testid": props.dataTestId
    }));


/***/ }),

/***/ 73830:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ Spacer),
/* harmony export */   X: () => (/* binding */ Row)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Row = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", (props)=>({
        display: "flex",
        flexDirection: "row",
        justifyContent: props.$align,
        alignItems: "center",
        gap: props.$gap
    }));
const Spacer = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    flexGrow: 1
});


/***/ }),

/***/ 29919:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Lv: () => (/* binding */ ButtonKind),
/* harmony export */   aH: () => (/* binding */ ButtonHoverSelector),
/* harmony export */   zx: () => (/* binding */ Button)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10334);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72221);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1898);
/* harmony import */ var baseui_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67710);
/* harmony import */ var baseui_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19895);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30242);
/* harmony import */ var _utils_KeyNormalizedControl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44122);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85728);


// eslint-disable-next-line no-restricted-imports






// eslint-disable-next-line no-restricted-imports

const ButtonHoverSelector = ":hover:not(:disabled):not(:active)";
/**
 * BaseUI reexport for minimal buttons because we need to pass overrides to style the text right. Wherever you want to use a <Button />, you should use this instead.
 * See https://github.com/uber/baseweb/issues/106 for more information
 */ const ButtonKind = {
    primary: "primary",
    secondary: "secondary",
    tertiary: "tertiary",
    minimal: "minimal",
    danger: "danger",
    delete: "delete",
    tertiaryDestructive: "tertiaryDestructive"
};
const Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .hQ)();
    const rawProps = {};
    const { disableButtons } = (0,_contexts__WEBPACK_IMPORTED_MODULE_4__/* .useWidgets */ .e)();
    const disabled = props.disabled ?? disableButtons?.(props);
    const kind = props.kind ?? "primary";
    const rawSize = props.size == "tight" ? baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact : props.size == "square" ? baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.default : props.size;
    let overrides = {
        BaseButton: {
            style: {
                cursor: disabled ? "not-allowed !important" : "pointer",
                transitionProperty: "background, background-color",
                transitionDuration: "0s",
                ":focus-visible": {
                    outline: `2px solid ${$theme.colors.borderFocus}`,
                    outlineOffset: "1px"
                },
                userSelect: "none"
            }
        },
        StartEnhancer: {
            style: {
                marginRight: $theme.sizing.scale300
            }
        },
        EndEnhancer: {
            style: {
                marginLeft: $theme.sizing.scale300
            }
        }
    };
    switch(props.size){
        case "tight":
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .N1)($theme.sizing.scale0)
                    }
                });
                break;
            }
        case baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.large:
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: {
                            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingVertical */ .i6)($theme.sizing.scale300),
                            ...$theme.typography.body
                        }
                    }
                });
                break;
            }
        case undefined:
        case baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact:
        case baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.default:
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .N1)($theme.sizing.scale200, $theme.sizing.scale500)
                    },
                    StartEnhancer: {
                        style: {
                            marginRight: $theme.sizing.scale400
                        }
                    }
                });
            }
    }
    const activeStyle = {
        backgroundColor: "transparent",
        boxShadow: "none",
        textDecoration: "underline"
    };
    const style = {
        primary: {
            backgroundColor: $theme.colors.primary700,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.neutralMax, 1, $theme.lighting.shadowButtonPrimary),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .expandBorderWidth */ .wW)(0),
            ":active:not(:disabled)": {
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.neutralMax, 0, $theme.lighting.shadowButtonPrimaryInset)
            },
            ":active:not(:disabled) > *": {
                transform: "translateY(1px)"
            },
            ":disabled": {
                backgroundColor: $theme.colors.alpha300,
                color: $theme.colors.primary50,
                boxShadow: "none"
            }
        },
        secondary: {
            color: $theme.colors.black,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.primary300, 1, $theme.lighting.shadowButton),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .expandBorderWidth */ .wW)(0),
            backgroundColor: $theme.colors.neutralMin,
            ":active:not(:disabled)": {
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.primary300, 1, $theme.lighting.shadowButtonInset),
                backgroundColor: $theme.colors.primary50
            },
            ":active:not(:disabled) > *": {
                transform: "translateY(1px)"
            },
            ":disabled": {
                backgroundColor: $theme.colors.alpha50,
                boxShadow: "none"
            }
        },
        tertiary: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .N1)("0px"),
            color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact ? $theme.colors.linkText : $theme.colors.contentLinkText,
            textDecoration: $theme.typography.contentLink?.textDecoration ?? "none",
            backgroundColor: "transparent",
            textUnderlineOffset: "3px",
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .expandBorderWidth */ .wW)(0),
            ":hover:not(:disabled)": {
                ...activeStyle
            },
            ":hover:not(:disabled):not(:active)": {
                ...activeStyle,
                color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact ? $theme.colors.linkHover : $theme.colors.contentLinkHover
            },
            ":focus-visible": {
                ...activeStyle,
                color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact ? $theme.colors.linkHover : $theme.colors.contentLinkHover,
                outlineOffset: "3px"
            },
            ":disabled": {
                color: $theme.colors.alpha400,
                backgroundColor: "transparent"
            },
            ":active:not(:disabled)": {
                ...activeStyle,
                color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .NO.compact ? $theme.colors.linkActive : $theme.colors.contentLinkActive,
                transform: "perspective(500px) translate3d(0, 0, -20px)"
            }
        },
        danger: {
            backgroundColor: $theme.colors.red500,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red600, 1, $theme.lighting.shadowButtonPrimary),
            ":hover:not(:disabled):not(:active)": {
                backgroundColor: $theme.colors.red400,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red500, 1, $theme.lighting.shadowButtonPrimary)
            },
            ":active:not(:disabled)": {
                backgroundColor: $theme.colors.red400,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red400, 1, $theme.lighting.shadowButtonPrimaryInset)
            },
            ":active:not(:disabled) > *": {
                transform: "translateY(1px)"
            },
            ":disabled": {
                boxShadow: "none",
                border: `1px solid ${$theme.colors.primary100}`
            }
        },
        delete: {
            color: $theme.colors.red500,
            backgroundColor: $theme.colors.neutralMin,
            boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red200, 1, $theme.lighting.shadowButton),
            ":hover:not(:disabled):not(:active)": {
                backgroundColor: $theme.colors.red50,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red300, 1, $theme.lighting.shadowButton)
            },
            ":active:not(:disabled)": {
                backgroundColor: $theme.colors.red50,
                boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderShadow */ .ic)($theme.colors.red400, 1, $theme.lighting.shadowButtonInset)
            },
            ":active:not(:disabled) > *": {
                transform: "translateY(1px)"
            },
            ":disabled": {
                boxShadow: "none",
                color: $theme.colors.primary50,
                backgroundColor: $theme.colors.primary300,
                border: `1px solid ${$theme.colors.primary300}`
            }
        },
        tertiaryDestructive: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .paddingUtil */ .N1)("0px"),
            color: $theme.colors.red500,
            backgroundColor: "transparent",
            ":hover:not(:disabled)": {
                backgroundColor: "transparent",
                boxShadow: "none"
            },
            ":hover:not(:disabled):not(:active)": {
                backgroundColor: "transparent",
                boxShadow: "none",
                color: $theme.colors.red600
            },
            ":focus-visible": {
                backgroundColor: "transparent",
                boxShadow: "none",
                color: $theme.colors.red600,
                outlineOffset: "3px"
            },
            ":active:not(:disabled)": {
                backgroundColor: "transparent",
                color: $theme.colors.red700,
                transform: "perspective(500px) translate3d(0, 0, -20px)"
            }
        }
    };
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
        BaseButton: {
            style: style[kind]
        }
    });
    if (props.$pressed) {
        const style = overrides.BaseButton?.style;
        if (style?.[":active:not(:disabled)"]) {
            lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(style, style[":active:not(:disabled)"]);
        }
    }
    overrides = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .mergeOverrides */ .aO)(overrides, props.overrides);
    // normalizeKeys is not a valid prop for Button
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(rawProps, lodash_omit__WEBPACK_IMPORTED_MODULE_1___default()(props, [
        "children",
        "normalizeKeys"
    ]));
    if (props.$style) {
        lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides.BaseButton.style, props.$style);
    }
    // wrap any child that is a raw string in a wrapper span, so that the CSS selectors which translate the children on active can target them. children that are already an element and not a string aren't wrapped to keep things as unchanged as possible
    // eslint-disable-next-line react/jsx-key
    const children = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(props.children, (child)=>{
        return typeof child === "string" ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
            style: {
                whiteSpace: overrides.BaseButton?.style?.whiteSpace ?? "pre-wrap"
            }
        }, child) : child;
    });
    const basewebKind = kind == "delete" ? "secondary" : kind == "danger" ? "primary" : kind == "tertiaryDestructive" ? "tertiary" : kind;
    const button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(baseui_button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        ref: ref,
        ...rawProps,
        disabled: disabled,
        overrides: overrides,
        kind: basewebKind,
        size: rawSize,
        draggable: props.draggable ? true : false
    }, children);
    return props.normalizeKeys ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_utils_KeyNormalizedControl__WEBPACK_IMPORTED_MODULE_9__/* .KeyNormalizedControl */ .w, {
        mode: "simple",
        ignoreKeyProps: {
            style: {
                lineHeight: "0"
            }
        }
    }, button) : button;
});


/***/ }),

/***/ 42331:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ PlainButton)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1898);



/**
 * A plain button component that doesn't apply any styling to the contents
 *
 * Useful for making clickable elements inside other things. Try to use this instead of a `div` or `Row` with an `onClick` :)
 */ const PlainButton = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("button", ({ $theme, $row, $selected, $style })=>{
    return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({
        fontFamily: "inherit",
        lineHeight: "inherit",
        fontWeight: "inherit",
        fontSize: "inherit",
        textDecoration: "underline",
        display: $row ? "flex" : "initial",
        alignItems: "center",
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandPadding */ .ft)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandMargin */ .ds)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandBorderWidth */ .wW)("0px"),
        backgroundColor: $selected ? $theme.colors.primary200 : "unset",
        width: "min-content",
        whiteSpace: "nowrap",
        textUnderlinePosition: "under",
        color: "unset",
        ":hover": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset",
            color: $theme.colors.contentTertiary,
            cursor: "pointer"
        },
        ":active": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset"
        },
        ":focus-visible": {
            outline: `auto 1px ${$theme.colors.borderFocus}`
        }
    }, $style);
});


/***/ }),

/***/ 85728:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: () => (/* binding */ WidgetsContext),
/* harmony export */   e: () => (/* binding */ useWidgets)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);

const WidgetsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
const useWidgets = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(WidgetsContext);
    return context ?? {};
};


/***/ }),

/***/ 49325:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ AccordionExpandIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74995);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);




const AccordionExpandIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)();
    let rotation = 0;
    if (props.direction == "down") {
        rotation = 90;
    } else if (props.direction == "left") {
        rotation = 180;
    } else if (props.direction == "up") {
        rotation = -90;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_3__/* .Svg */ .n, {
        viewBox: "0 0 30 30",
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(props, "direction")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
        d: "M20.625 15.0001C20.625 15.1974 20.5494 15.3948 20.3991 15.5451L12.6908 23.2534C12.4704 23.4738 12.1389 23.5401 11.8506 23.4207C11.5623 23.3019 11.375 23.0198 11.375 22.7084V7.29179C11.375 6.98037 11.5623 6.69825 11.8506 6.57954C12.1389 6.46006 12.4704 6.52635 12.6908 6.74681L20.3991 14.4551C20.5494 14.6054 20.625 14.8028 20.625 15.0001Z",
        fill: props.color || $theme.colors.contentSecondary,
        transform: `rotate(${rotation} 15 15)`
    }));
};


/***/ }),

/***/ 33619:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ CloseIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const CloseIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.14478 3.17316C2.18007 3.34135 2.26456 3.49524 2.3875 3.61529L6.77382 8.00162L2.38794 12.3875C2.3055 12.4671 2.23964 12.5622 2.19418 12.6673C2.14843 12.7732 2.12426 12.8871 2.12309 13.0024C2.12192 13.1177 2.14376 13.2321 2.18735 13.3388C2.23093 13.4456 2.29537 13.5426 2.37691 13.6241C2.45844 13.7056 2.55542 13.7701 2.66217 13.8136C2.76893 13.8572 2.8833 13.8791 2.9986 13.8779C3.1139 13.8767 3.22781 13.8526 3.33365 13.8068C3.43883 13.7614 3.53395 13.6955 3.6135 13.613L7.99937 9.22717L12.3853 13.613C12.4648 13.6955 12.5599 13.7614 12.6651 13.8068C12.7709 13.8526 12.8848 13.8767 13.0001 13.8779C13.1155 13.8791 13.2298 13.8572 13.3366 13.8136C13.4433 13.7701 13.5403 13.7056 13.6218 13.6241C13.7034 13.5426 13.7678 13.4456 13.8114 13.3388C13.855 13.2321 13.8768 13.1177 13.8757 13.0024C13.8745 12.8871 13.8503 12.7732 13.8046 12.6673C13.7591 12.5622 13.6932 12.4671 13.6108 12.3875L9.22492 8.00162L13.6108 3.61576C13.736 3.49505 13.822 3.33945 13.8576 3.16917C13.8934 2.99815 13.8767 2.82032 13.8096 2.65899C13.7425 2.49766 13.6282 2.36037 13.4818 2.26512C13.3353 2.16987 13.1635 2.12111 12.9888 2.12524C12.7605 2.13063 12.5436 2.22588 12.3852 2.39025L7.99937 6.77607L3.61306 2.38975C3.5324 2.30713 3.43605 2.24144 3.32965 2.19657C3.2228 2.1515 3.10793 2.12834 2.99196 2.12844C2.81963 2.12866 2.65127 2.18024 2.5084 2.2766C2.36553 2.37296 2.25462 2.50972 2.18985 2.66942C2.12508 2.82912 2.10939 3.0045 2.14478 3.17316Z"
    }));


/***/ }),

/***/ 65699:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: () => (/* binding */ ExternalLinkIcon)
/* harmony export */ });
/* unused harmony export ExternalLinkIconBox */
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


// Arrow pointing through the top right corner of a square outline
const ExternalLinkIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M13.653 1.66042C13.6284 1.66123 13.6038 1.66341 13.5794 1.66693H9.33268C9.24434 1.66568 9.15663 1.68201 9.07465 1.71495C8.99267 1.74789 8.91806 1.7968 8.85515 1.85883C8.79223 1.92086 8.74228 1.99477 8.70818 2.07628C8.67408 2.15778 8.65652 2.24525 8.65652 2.3336C8.65652 2.42195 8.67408 2.50942 8.70818 2.59092C8.74228 2.67243 8.79223 2.74634 8.85515 2.80837C8.91806 2.8704 8.99267 2.91931 9.07465 2.95225C9.15663 2.9852 9.24434 3.00152 9.33268 3.00027H12.0566L7.528 7.52891C7.46401 7.59034 7.41293 7.66392 7.37774 7.74534C7.34255 7.82676 7.32396 7.91438 7.32305 8.00308C7.32215 8.09177 7.33896 8.17975 7.37248 8.26187C7.40601 8.34399 7.45558 8.4186 7.5183 8.48131C7.58102 8.54403 7.65562 8.59361 7.73774 8.62713C7.81986 8.66066 7.90785 8.67746 7.99654 8.67656C8.08523 8.67566 8.17286 8.65707 8.25427 8.62188C8.33569 8.58669 8.40927 8.5356 8.4707 8.47162L12.9993 3.94298V6.66693C12.9981 6.75528 13.0144 6.84298 13.0474 6.92496C13.0803 7.00694 13.1292 7.08156 13.1912 7.14447C13.2533 7.20738 13.3272 7.25734 13.4087 7.29144C13.4902 7.32554 13.5777 7.3431 13.666 7.3431C13.7544 7.3431 13.8418 7.32554 13.9233 7.29144C14.0048 7.25734 14.0788 7.20738 14.1408 7.14447C14.2028 7.08156 14.2517 7.00694 14.2847 6.92496C14.3176 6.84298 14.3339 6.75528 14.3327 6.66693V2.41563C14.3455 2.31985 14.3374 2.22241 14.3089 2.13007C14.2804 2.03774 14.2321 1.9527 14.1675 1.88087C14.1028 1.80903 14.0233 1.75211 13.9345 1.71405C13.8456 1.67598 13.7496 1.65769 13.653 1.66042ZM4.16602 2.66693C2.79358 2.66693 1.66602 3.7945 1.66602 5.16693V11.8336C1.66602 13.206 2.79358 14.3336 4.16602 14.3336H10.8327C12.2051 14.3336 13.3327 13.206 13.3327 11.8336V8.66693C13.3339 8.57859 13.3176 8.49088 13.2847 8.40891C13.2517 8.32693 13.2028 8.25231 13.1408 8.1894C13.0788 8.12649 13.0048 8.07653 12.9233 8.04243C12.8418 8.00833 12.7544 7.99077 12.666 7.99077C12.5777 7.99077 12.4902 8.00833 12.4087 8.04243C12.3272 8.07653 12.2533 8.12649 12.1912 8.1894C12.1292 8.25231 12.0803 8.32693 12.0474 8.40891C12.0144 8.49088 11.9981 8.57859 11.9993 8.66693V11.8336C11.9993 12.4825 11.4816 13.0003 10.8327 13.0003H4.16602C3.51712 13.0003 2.99935 12.4825 2.99935 11.8336V5.16693C2.99935 4.51804 3.51712 4.00027 4.16602 4.00027H7.33268C7.42102 4.00152 7.50873 3.9852 7.59071 3.95225C7.67269 3.91931 7.7473 3.8704 7.81022 3.80837C7.87313 3.74634 7.92309 3.67243 7.95719 3.59092C7.99128 3.50942 8.00884 3.42195 8.00884 3.3336C8.00884 3.24525 7.99128 3.15778 7.95719 3.07628C7.92309 2.99477 7.87313 2.92086 7.81022 2.85883C7.7473 2.7968 7.67269 2.74789 7.59071 2.71495C7.50873 2.68201 7.42102 2.66568 7.33268 2.66693H4.16602Z"
    }));
// Solid colored box with an internal arrow pointing to top right corner
const ExternalLinkIconBox = (props)=>/*#__PURE__*/ React.createElement(StyledSvg, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.1667 2H3.83333C2.82233 2 2 2.82267 2 3.83333V12.1667C2 13.1773 2.82233 14 3.83333 14H12.1667C13.1777 14 14 13.1773 14 12.1667V3.83333C14 2.82267 13.1777 2 12.1667 2ZM12 8.16667C12 8.44267 11.7763 8.66667 11.5 8.66667C11.2237 8.66667 11 8.44267 11 8.16667V5.707L5.85367 10.8537C5.756 10.9513 5.628 11 5.5 11C5.372 11 5.244 10.9513 5.14633 10.8537C4.951 10.6583 4.951 10.342 5.14633 10.1467L10.293 5H7.83333C7.557 5 7.33333 4.776 7.33333 4.5C7.33333 4.224 7.557 4 7.83333 4H11.5C11.7763 4 12 4.224 12 4.5V8.16667Z"
    })));


/***/ }),

/***/ 69811:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  M: () => (/* binding */ GadgetLogoMark),
  u: () => (/* binding */ GadgetLogoType)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/assets/logomark.svg
/* harmony default export */ const logomark = (__webpack_require__.p + "1b5b906861f70ec70ea51c35c1e023be.svg");
;// CONCATENATED MODULE: ../@gadgetinc/widgets/assets/logotype.svg
/* harmony default export */ const logotype = (__webpack_require__.p + "13513703c5b41ce947547e20671b9409.svg");
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx



const GadgetLogoType = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logotype
    });
};
const GadgetLogoMark = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logomark
    });
};


/***/ }),

/***/ 90159:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: () => (/* binding */ WarningIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



const WarningIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        x: "7",
        y: "5",
        width: "2",
        height: "8",
        fill: "transparent"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M7.99998 1.59998C7.55648 1.59998 7.17655 1.87023 7.01561 2.25518L1.22707 12.2385V12.2396C1.1226 12.4078 1.06705 12.6019 1.06665 12.8C1.06665 13.0829 1.17903 13.3542 1.37907 13.5542C1.57911 13.7543 1.85042 13.8666 2.13332 13.8666C2.15835 13.8665 2.18336 13.8654 2.20832 13.8635L2.2104 13.8666H7.99998H13.7896L13.7917 13.8625C13.8166 13.8647 13.8416 13.8661 13.8667 13.8666C14.1495 13.8666 14.4209 13.7543 14.6209 13.5542C14.8209 13.3542 14.9333 13.0829 14.9333 12.8C14.9331 12.6015 14.8776 12.4071 14.7729 12.2385L14.7646 12.2239C14.7642 12.2236 14.7639 12.2232 14.7635 12.2229L8.98436 2.25518C8.82342 1.87023 8.44349 1.59998 7.99998 1.59998ZM7.35311 6.05831H8.64686L8.53957 9.51039H7.4604L7.35311 6.05831ZM8.00207 10.5656C8.44047 10.5656 8.70311 10.8015 8.70311 11.2041C8.70311 11.5993 8.44047 11.8343 8.00207 11.8343C7.56047 11.8343 7.29582 11.5993 7.29582 11.2041C7.29582 10.8015 7.55993 10.5656 8.00207 10.5656Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.yellow500)
    }));
};


/***/ }),

/***/ 75580:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Dh: () => (/* binding */ space),
/* harmony export */   Ql: () => (/* binding */ gadgetColorsDark),
/* harmony export */   Ro: () => (/* binding */ gadgetShadows),
/* harmony export */   d_: () => (/* binding */ gadgetColorsLight),
/* harmony export */   pD: () => (/* binding */ radii),
/* harmony export */   uQ: () => (/* binding */ productTypography),
/* harmony export */   zG: () => (/* binding */ getPrimitiveColors)
/* harmony export */ });
const gadgetColorsLight = {
    neutralMin: "#FFF",
    neutralMax: "#000",
    primary50: "#F6F6F6",
    primary100: "#EEEEEE",
    primary200: "#E2E2E2",
    primary300: "#CBCBCB",
    primary400: "#AFAFAF",
    primary500: "#757575",
    primary600: "#545454",
    primary700: "#333333",
    alpha0: "rgba(0, 0, 0, 0)",
    alpha50: "rgba(0, 0, 0, 0.03)",
    alpha100: "rgba(0, 0, 0, 0.07)",
    alpha200: "rgba(0, 0, 0, 0.11)",
    alpha300: "rgba(0, 0, 0, 0.2)",
    alpha400: "rgba(0, 0, 0, 0.31)",
    alpha500: "rgba(0, 0, 0, 0.54)",
    alpha600: "rgba(0, 0, 0, 0.67)",
    alpha700: "rgba(0, 0, 0, 0.8)",
    alpha800: "rgba(0, 0, 0, 0.9)",
    alpha900: "rgba(0, 0, 0, 0.95)",
    electricBlue50: "#ECECFF",
    electricBlue100: "#D9D9FE",
    electricBlue200: "#B3B3FE",
    electricBlue300: "#8E8EFD",
    electricBlue400: "#6868FD",
    electricBlue500: "#4242FC",
    electricBlue600: "#3535CE",
    electricBlue700: "#2828A0",
    yellow50: "#FFF8EC",
    yellow100: "#FDEDD6",
    yellow200: "#FBE6BC",
    yellow300: "#FACF8F",
    yellow400: "#FCBC63",
    yellow500: "#DC892A",
    yellow600: "#A66822",
    yellow700: "#6F4616",
    red50: "#FFEDEB",
    red100: "#FFDBD7",
    red200: "#F7AEA6",
    red300: "#F27769",
    red400: "#DB3927",
    red500: "#B13325",
    red600: "#8C2B20",
    red700: "#6D1F17",
    green50: "#F0F9F4",
    green100: "#DAF0E3",
    green200: "#AEDDC2",
    green300: "#73C496",
    green400: "#3AA76D",
    green500: "#368759",
    green600: "#2B6B46",
    green700: "#1C472F",
    blue50: "#F0F3FD",
    blue100: "#D7E2FA",
    blue200: "#A6BEF3",
    blue300: "#6790EE",
    blue400: "#3B6CE9",
    blue500: "#2D53B1",
    blue600: "#23418C",
    blue700: "#172B5D",
    cyan50: "#EFF8FF",
    cyan100: "#D2EFFF",
    cyan200: "#B6E5FF",
    cyan300: "#92D7FE",
    cyan400: "#63C7FF",
    cyan500: "#3A9BD1",
    cyan600: "#3383AF",
    cyan700: "#1B5B80",
    purple50: "#F7F5FD",
    purple100: "#F1EBFF",
    purple200: "#DBCBFF",
    purple300: "#BEA1FF",
    purple400: "#9E72FE",
    purple500: "#6F4BCD",
    purple600: "#5B38B6",
    purple700: "#3B227A",
    purpleAlpha50: "rgba(62, 14, 169, 0.04)",
    purpleAlpha100: "#4F00FF14",
    purpleAlpha200: "#5407FE36",
    purpleAlpha300: "#5407FE61",
    purpleAlpha400: "#5407FE91",
    purpleAlpha500: "#4208C2BF",
    purpleAlpha600: "#3500ABCC",
    purpleAlpha700: "#210066DE",
    gellyPurple: "#9B50D7",
    development: "#404B5A",
    disabledDevelopment: "#404B5AB2",
    backgroundDevelopment: "rgba(162, 185, 215, 0.21)",
    inputAlpha: "rgba(0, 0, 0, 0.01)",
    splashIllustrationBackground: "#F8F8FE",
    backgroundEnvironmentSettingsCalloutDevelopment: "#EBF0F6",
    contentEnvironmentSettingsCalloutDevelopment: "rgba(64, 75, 90, 0.60)",
    backgroundEnvironmentSettingsCalloutProduction: "#F2EDFD",
    contentEnvironmentSettingsCalloutProduction: "#5634AE99"
};
const gadgetColorsDark = {
    neutralMin: "#000",
    neutralMax: "#FFF",
    primary50: "#333333",
    primary100: "#545454",
    primary200: "#757575",
    primary300: "#AFAFAF",
    primary400: "#CBCBCB",
    primary500: "#E2E2E2",
    primary600: "#EEEEEE",
    primary700: "#F6F6F6",
    alpha0: "rgba(255, 255, 255, 0)",
    alpha50: "rgba(255, 255, 255, 0.03)",
    alpha100: "rgba(255, 255, 255, 0.07)",
    alpha200: "rgba(255, 255, 255, 0.11)",
    alpha300: "rgba(255, 255, 255, 0.2)",
    alpha400: "rgba(255, 255, 255, 0.31)",
    alpha500: "rgba(255, 255, 255, 0.54)",
    alpha600: "rgba(255, 255, 255, 0.67)",
    alpha700: "rgba(255, 255, 255, 0.8)",
    alpha800: "rgba(255, 255, 255, 0.9)",
    alpha900: "rgba(255, 255, 255, 0.95)",
    electricBlue50: "#2828A0",
    electricBlue100: "#3535CE",
    electricBlue200: "#4242FC",
    electricBlue300: "#6868FD",
    electricBlue400: "#8E8EFD",
    electricBlue500: "#B3B3FE",
    electricBlue600: "#D9D9FE",
    electricBlue700: "#ECECFF",
    yellow50: "#6F4616",
    yellow100: "#A66822",
    yellow200: "#DC892A",
    yellow300: "#FCBC63",
    yellow400: "#FACF8F",
    yellow500: "#FBE6BC",
    yellow600: "#FDEDD6",
    yellow700: "#FFF8EC",
    red50: "#6D1F17",
    red100: "#8C2B20",
    red200: "#B13325",
    red300: "#DB3927",
    red400: "#F27769",
    red500: "#F7AEA6",
    red600: "#FFDBD7",
    red700: "#FFEDEB",
    green50: "#1C472F",
    green100: "#2B6B46",
    green200: "#368759",
    green300: "#3AA76D",
    green400: "#73C496",
    green500: "#AEDDC2",
    green600: "#DAF0E3",
    green700: "#F0F9F4",
    blue50: "#172B5D",
    blue100: "#23418C",
    blue200: "#2D53B1",
    blue300: "#3B6CE9",
    blue400: "#6790EE",
    blue500: "#A6BEF3",
    blue600: "#D7E2FA",
    blue700: "#F0F3FD",
    cyan50: "#1B5B80",
    cyan100: "#3383AF",
    cyan200: "#3A9BD1",
    cyan300: "#63C7FF",
    cyan400: "#92D7FE",
    cyan500: "#B6E5FF",
    cyan600: "#D2EFFF",
    cyan700: "#EFF8FF",
    purple50: "#261650",
    purple100: "#361D77",
    purple200: "#5D39BB",
    purple300: "#7340E4",
    purple400: "#9168EC",
    purple500: "#BFA8F2",
    purple600: "#E3D7FD",
    purple700: "#F5F2FC",
    purpleAlpha50: "#210066DE",
    purpleAlpha100: "#3500ABCC",
    purpleAlpha200: "#4208C2BF",
    purpleAlpha300: "#5407FE91",
    purpleAlpha400: "#5407FE61",
    purpleAlpha500: "#5407FE36",
    purpleAlpha600: "#4F00FF14",
    purpleAlpha700: "rgba(62, 14, 169, 0.04)",
    gellyPurple: "#8d3ccf",
    development: "#404B5A",
    disabledDevelopment: "#404B5AB2",
    backgroundDevelopment: "rgba(162, 185, 215, 0.21)",
    inputAlpha: "rgba(0, 0, 0, 0.01)",
    splashIllustrationBackground: "#F8F8FE",
    backgroundEnvironmentSettingsCalloutDevelopment: "#EBF0F6",
    contentEnvironmentSettingsCalloutDevelopment: "rgba(64, 75, 90, 0.60)",
    backgroundEnvironmentSettingsCalloutProduction: "#F2EDFD",
    contentEnvironmentSettingsCalloutProduction: "#5634AE99"
};
const gadgetShadows = {
    selected: "0px 2px 0px 1px rgb(66, 66, 252, 0.3)",
    depth2: "0px 3px 2px -1px rgba(0, 0, 0, 0.12)",
    depth3: "0px 8px 16px -4px rgba(0, 0, 0, 0.24)",
    depth4: "0px 12px 20px -8px rgba(0, 0, 0, 0.32)",
    shadowButton: "0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16)",
    shadowButtonPrimary: "0px -2px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16)",
    shadowButtonInset: "0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset",
    shadowButtonPrimaryInset: "0px 2px 2px 0px rgba(0, 0, 0, 0.32) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.16) inset, -1px 0px 1px 0px rgba(0, 0, 0, 0.16) inset",
    shadowInputInset: "0px 1px 1px 0px rgba(0, 0, 0, 0.08) inset"
};
const productTypography = {
    title: {
        fontFamily: "Inconsolata",
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: "30px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    navTitle: {
        fontFamily: "Inconsolata",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: "1px",
        textAlign: "left"
    },
    heading: {
        fontFamily: "Inconsolata",
        fontSize: "16px",
        fontWeight: 700,
        lineHeight: "22px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    subHeading: {
        fontFamily: "Inconsolata",
        fontSize: "14px",
        fontWeight: 700,
        lineHeight: "20px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    body: {
        fontFamily: "Inconsolata",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    caption: {
        fontFamily: "Inconsolata",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    contentLink: {
        textDecoration: "none"
    }
};
const getPrimitiveColors = (palette)=>({
        accent: palette.electricBlue500,
        accent50: palette.purple50,
        accent100: palette.purple100,
        accent200: palette.purple200,
        accent300: palette.purple300,
        accent400: palette.purple400,
        accent500: palette.purple500,
        accent600: palette.purple600,
        accent700: palette.purple700,
        negative50: palette.red50,
        negative100: palette.red100,
        negative200: palette.red200,
        negative300: palette.red300,
        negative400: palette.red400,
        negative500: palette.red500,
        negative600: palette.red600,
        negative700: palette.red700,
        warning50: palette.yellow50,
        warning100: palette.yellow100,
        warning200: palette.yellow200,
        warning300: palette.yellow300,
        warning400: palette.yellow400,
        warning500: palette.yellow500,
        warning600: palette.yellow600,
        warning700: palette.yellow700,
        positive50: palette.green50,
        positive100: palette.green100,
        positive200: palette.green200,
        positive300: palette.green300,
        positive400: palette.green400,
        positive500: palette.green500,
        positive600: palette.green600,
        positive700: palette.green700,
        primary50: palette.primary50,
        primary100: palette.primary100,
        primary200: palette.primary200,
        primary300: palette.primary300,
        primary400: palette.primary400,
        primary500: palette.primary500,
        primary600: palette.primary600,
        primary700: palette.primary700
    });
const space = {
    scale0: "2px",
    scale100: "4px",
    scale200: "6px",
    scale300: "8px",
    scale400: "10px",
    scale500: "12px",
    scale550: "14px",
    scale600: "16px",
    scale650: "18px",
    scale700: "20px",
    scale750: "22px",
    scale800: "24px",
    scale850: "28px",
    scale900: "32px",
    scale950: "36px",
    scale1000: "40px",
    scale1200: "48px",
    scale1400: "56px",
    scale1600: "64px",
    scale2400: "96px",
    scale3200: "128px",
    scale4800: "192px"
};
const radii = {
    radius100: "2px",
    radius200: "4px",
    radius300: "8px",
    radius400: "12px"
};


/***/ }),

/***/ 44122:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  w: () => (/* binding */ KeyNormalizedControl)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.12.3_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 16 modules
var es = __webpack_require__(16604);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-hotkeys-ce@2.0.6_react@0.0.0-experimental-4ead6b530/node_modules/react-hotkeys-ce/index.es.js
var index_es = __webpack_require__(26722);
// EXTERNAL MODULE: ../@gadgetinc/errors/index.ts
var errors = __webpack_require__(24818);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/toast/toaster.js + 2 modules
var toaster = __webpack_require__(95150);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/utils/feedback.tsx


const messageWithoutCode = (message)=>{
    return message.substring(message.indexOf(":") + 1);
};
const tryWithUserFeedback = (action)=>{
    try {
        action();
    } catch (error) {
        if (error instanceof errors/* UserInitiatedActionSemanticError */.fE) {
            toaster/* default */.Z.negative(messageWithoutCode(error.message), {
                autoHideDuration: 3000
            });
        } else {
            throw error;
        }
    }
};

;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/utils/KeyNormalizedControl.tsx





const KeyNormalizedControl = (0,es/* observer */.Pi)((props)=>{
    const [, $theme] = (0,styled/* useStyletron */.hQ)();
    const ignoreKeyProps = {
        ...props.ignoreKeyProps ?? {}
    };
    const hotKeyProps = {
        handlers: {},
        keyMap: {}
    };
    const baseExceptions = [
        "escape",
        "meta",
        "ctrl",
        "shift",
        "p",
        "k"
    ];
    if (props.mode == "form") {
        ignoreKeyProps.only = [
            "up",
            "down",
            "left",
            "right",
            "enter",
            "space",
            "Delete",
            "backspace"
        ];
    } else if (props.mode == "simple") {
        ignoreKeyProps.only = [
            "enter",
            "space"
        ];
    } else if (props.mode == "select") {
        ignoreKeyProps.except = baseExceptions;
    } else if (props.mode == "textarea") {
        ignoreKeyProps.except = baseExceptions;
    } else if (props.engagementBoundary) {
        ignoreKeyProps.except = [
            ...baseExceptions,
            "up",
            "down"
        ];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hotKeyProps.keyMap["FINISHED_EDITING"] = [
            "enter"
        ];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hotKeyProps.handlers["FINISHED_EDITING"] = (event)=>{
            event?.preventDefault();
            tryWithUserFeedback(()=>props.onFinish?.());
        };
    } else {
        ignoreKeyProps.except = [
            ...baseExceptions,
            "up",
            "down",
            "enter"
        ];
    }
    const innerContent = /*#__PURE__*/ react.createElement(index_es.IgnoreKeys, ignoreKeyProps, props.children);
    return props.hasHotKeys ? /*#__PURE__*/ react.createElement(index_es.HotKeys, {
        ...hotKeyProps,
        style: {
            minHeight: "32px"
        }
    }, innerContent) : innerContent;
});


/***/ }),

/***/ 97888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  p: () => (/* binding */ CurrentFlags),
  WN: () => (/* binding */ Flag),
  Q_: () => (/* binding */ FlagsProvider),
  P5: () => (/* binding */ useFlag),
  Vb: () => (/* binding */ useFlags)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/flag@4.4.0_@types+react-dom@17.0.5_@types+react@17.0.4_react-dom@0.0.0-experimental-4ead6b530_5wujmyu4zyhz3ob3w23lepq2am/node_modules/flag/build/index.js
var build = __webpack_require__(18988);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/merge.js
var merge = __webpack_require__(88469);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx@6.12.3/node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(66204);
// EXTERNAL MODULE: ../state-trees/src/type-system/FieldType.ts
var FieldType = __webpack_require__(54930);
;// CONCATENATED MODULE: ../state-trees/src/GadgetFlags.ts


/** Default flag state used for tests in state-trees and web */ const TestFlagDefaultState = {
    features: {
        fieldTypes: {
            [FieldType/* FieldType */.fS.Computed]: false,
            [FieldType/* FieldType */.fS.Color]: false,
            [FieldType/* FieldType */.fS.Money]: false
        },
        typescript: false,
        darkMode: false,
        defaultLanguageSelection: false,
        ideJSErrorChecking: false,
        actionsAsCode: false,
        fileBasedActions: false,
        computedViews: true,
        editorCodeGen: false,
        actionsExplainerPopup: false,
        shopifyPayloadFilters: false,
        stateInActionCode: false,
        codeMirrorEditor: false,
        shopifyCustomerAuthentication: false,
        elasticsearchSearchAPI: false,
        customerAuthenticationV2: false,
        computedFieldFiltering: true,
        bigCommerceConnection: true,
        editorAssistant: true,
        aiEarlyAdopters: false
    },
    internal: {
        websocketRateLimitMode: "enforce",
        canarySandbox: false,
        stagingLoki: false,
        rateLimitMode: "enforce",
        shopifyWebhookLoopDetection: false,
        upgradingFission: false,
        upgradingMainNodes: false,
        dedicatedColumnsStrategy: false,
        apiKeysInBrowserClients: true,
        throttleExchange: false,
        edgeFrameworkVersion: false,
        blackholeWebhooks: false,
        selectFrameworkVersionOnCreate: false,
        gellyVersion: "main",
        useTemporalBlueCluster: false,
        skipSearchVectorUpdate: false,
        gellyFilterSortCompiler: true
    }
};
const ClientSideDefaultFlags = merge_default()({}, TestFlagDefaultState, {
    features: {
        editorCodeGen: false
    }
});

;// CONCATENATED MODULE: ./src/lib/flags.ts





const { FlagsProvider, Flag, useFlag, useFlags } = (0,build/* default */.ZP)();
const CurrentFlags = (0,mobx_esm.observable)(typeof window === "undefined" ? ClientSideDefaultFlags : window.GadgetFlags);
if (typeof window !== "undefined") {
    /** Utility for setting flag values in tests */ window.mockFlags = (newFlags)=>{
        merge_default()(CurrentFlags, newFlags);
    };
}


/***/ })

}]);